var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "modal",
    attrs: {
      id: "template-email-modal",
      "loaders-disabled": "",
      "modal-dialog-size": "xl",
      "modal-class": "checklist-template-editor-modal",
    },
    on: { hidden: _vm.handleHidden },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _vm._v(
              "\n    " + _vm._s(_vm.$t("documents.templateEditor")) + "\n  "
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c(
              "div",
              { staticClass: "form-group" },
              [
                _c("label", { attrs: { for: "checklist-template-dropdown" } }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("documents.selectTemplate")) +
                      "\n      "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "align-items": "center",
                      padding: "16px 0",
                      "justify-content": "flex-start",
                    },
                  },
                  [
                    _c(
                      "material-input",
                      {
                        staticStyle: {
                          "min-width": "180px",
                          "margin-bottom": "0",
                        },
                      },
                      [
                        _c("v-select-field", {
                          staticClass: "simple-dd",
                          attrs: {
                            id: "checklist-template-dropdown",
                            options: _vm.checklistNames,
                            scenario: "simple",
                            "default-value": _vm.selectedName,
                            placeholder: _vm.$t("documents.searchByName"),
                            name: "template",
                          },
                          on: {
                            "option:selected": _vm.selectTemplate,
                            clear: _vm.clear,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.selectedTemplateId
                      ? _c("inline-prompt", {
                          staticStyle: {
                            "margin-left": "8px",
                            "min-width": "80px",
                          },
                          attrs: {
                            "action-type": "delete",
                            loading: _vm.loading,
                            "confirmation-text": _vm.$t(
                              "documents.deleteTemplateConfirmation"
                            ),
                          },
                          on: { accept: _vm.handleDeleteTemplate },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary",
                        staticStyle: {
                          "margin-left": "200px",
                          "white-space": "nowrap",
                          "flex-shrink": "0",
                          width: "auto",
                        },
                        attrs: { disabled: !_vm.isNotEmpty },
                        on: { click: _vm.openSaveModal },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("boards.actions.saveAsNewTemplate")) +
                            "\n        "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      width: "50%",
                      "min-width": "250px",
                      "text-align": "left",
                    },
                  },
                  [
                    _c("checklist-component", {
                      attrs: {
                        "is-editor": true,
                        title: _vm.currentTemplate.title,
                        checklist: _vm.currentTemplate.checklist,
                      },
                      on: { input: _vm.handleUpdate },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("save-checklist-modal", {
                  ref: "saveChecklistModal",
                  attrs: {
                    loading: _vm.loading,
                    "checklist-templates": _vm.checklistTemplates,
                  },
                  on: { submit: _vm.saveNewTemplate },
                }),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _vm.difference
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    on: { click: _vm.loadTemplate },
                  },
                  [
                    _vm._v(
                      "\n      " +
                        _vm._s(_vm.$t("global.actions.load")) +
                        "\n    "
                    ),
                  ]
                )
              : _vm._e(),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }